var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "condition-group" }, [
    _c("div", { staticClass: "space-y-4 condition-list" }, [
      _c(
        "div",
        { staticClass: "grid grid-cols-2 items-center condition-row" },
        [
          _c("div", { staticClass: "custom-control custom-checkbox" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.applyToSubFolder.value,
                  expression: "applyToSubFolder.value"
                }
              ],
              staticClass: "custom-control-input",
              attrs: { type: "checkbox", id: "checkConfirmationRead" },
              domProps: {
                checked: Array.isArray(_vm.applyToSubFolder.value)
                  ? _vm._i(_vm.applyToSubFolder.value, null) > -1
                  : _vm.applyToSubFolder.value
              },
              on: {
                input: function($event) {
                  return _vm.$emit("saveMeta", {
                    key: "applyToSubFolder",
                    value: $event.target.checked
                  })
                },
                change: function($event) {
                  var $$a = _vm.applyToSubFolder.value,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.applyToSubFolder,
                          "value",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.applyToSubFolder,
                          "value",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.applyToSubFolder, "value", $$c)
                  }
                }
              }
            }),
            _c(
              "label",
              {
                staticClass: "custom-control-label",
                attrs: { for: "checkConfirmationRead" }
              },
              [_vm._v(" Esta regla aplica a las sub-carpetas ")]
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }